import React, { CSSProperties, Component } from 'react'
import dayjs from 'dayjs'

import { groupDependentFields } from '../../common/utils'
import PdfExport from './PdfExport'
import { Header, PageNumbers, RiskOutcomeScore, Title } from './pdfContent'
import { tableStyles } from './styles'
import { formatFormField } from './pdfForms'
import { Carer, Resident, RiskAssessment } from '@lmc/ts-common'
import { splitString } from './utils'

interface Props {
  carer: Carer
  riskAssessment: RiskAssessment
  resident: Resident
  disabled: boolean
  style: CSSProperties
  title: string
}

class RiskAssessmentPdfExport extends Component<Props> {
  formatDate = (date: string) => dayjs(date).format('DD-MM-YYYY')

  formatTime = (time: string) => dayjs(time).format('HH:mm')

  getName = (item: Resident) => `${item.name.first} ${item.name.last}`

  // @ts-ignore
  // @ts-nocheck
  getRiskAssessmentDoc = () => {
    const {
      carer,
      riskAssessment: {
        createdOn,
        reviewedOn,
        form: { formFields, name },
        formData,
        riskLevel,
        riskScore,
      },
      resident,
    } = this.props

    if (!formData || !formFields) return null

    const withDependentFields = groupDependentFields(formFields)
    const lastUpdateText = `${this.formatDate(
      // @ts-ignore
      reviewedOn || createdOn
      // @ts-ignore
    )} at ${this.formatTime(reviewedOn || createdOn)} - ${this.getName(carer)}`

    let content: any[] = [
      // @ts-ignore
      Header({
        title: `${this.getName(resident)} - ${name}`,
      }),
      Title({ title: 'Last update', style: 'h2' }),
      {
        text: lastUpdateText,
        textStyle: 'tableHeaderSmall',
        margin: [0, 0, 0, 30],
      },
    ]

    if (riskLevel || formData.actions) {
      content = [
        ...content,
        {
          columns: [
            riskLevel
              ? [
                  Title({ title: 'Outcome Risk Score', style: 'h2' }),
                  // @ts-ignore
                  RiskOutcomeScore(riskLevel, riskScore),
                ]
              : null,
            formData.actions
              ? [
                  Title({ title: 'Actions', style: 'h2' }),
                  {
                    text: splitString(formData.actions as string, 20),
                    style: 'tableHeaderSmall',
                  },
                ]
              : null,
          ],
          margin: [0, 0, 0, 30],
        },
      ]
    }

    return {
      content: [
        ...content,
        ...withDependentFields.map((field) =>
          formatFormField({ formData, ...field })
        ),
      ],
      footer: PageNumbers,
      styles: tableStyles,
    }
  }

  getDocDefinition = () => {
    const { carer, riskAssessment, resident } = this.props
    return new Promise((resolve, reject) => {
      if (!carer || !riskAssessment || !riskAssessment.form || !resident) {
        reject('Data not provided')
      } else {
        resolve(this.getRiskAssessmentDoc())
      }
    })
  }

  render() {
    const { disabled, style, title } = this.props
    return (
      <PdfExport
        getDocDefinition={this.getDocDefinition}
        pdfTitle={title}
        style={style}
        // @ts-ignore
        disabled={disabled}
      />
    )
  }
}

export default RiskAssessmentPdfExport
